import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import { FormikContextType } from 'formik';
import { ReactElement, useEffect } from 'react';
import withComponentLoader from '../../../../hoc/withComponentLoader';
import AppWrappedInput from './AppWrappedInput';

/**
 * Date input base component stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @param {Function} props.setLoading setter function coming from `withComponentLoader` HOC
 * @param {string} props.label display text
 * @param {FormikContextType} props.formik full Formik Context
 * @param {string|ReactElement} hprops.elperText helper text
 * @param {boolean} props.isRequired flag to determine whether to show required indicator
 * @param {boolean} props.isLoading flag to indicate the loading state (comes from parent)
 * @param {object} props.props the rest of the props
 * @returns Date input stylized for custom
 */
const AppWrappedDate = ({
	setLoading,
	label,
	formik,
	helperText,
	isRequired = false,
	isLoading = false,
	...props
}) => {
	useEffect(() => {
		setLoading(isLoading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	return (
		<AppWrappedInput
			label={label}
			error={
				formik.touched[props.name] ? formik.errors[props.name] : null
			}
			isRequired={isRequired}
		>
			<FormControl variant='filled' fullWidth>
				<TextField
					fullWidth
					variant='filled'
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					value={formik.values[props.name]}
					name={props.name}
					type='date'
				/>
				<FormHelperText>{helperText}</FormHelperText>
			</FormControl>
		</AppWrappedInput>
	);
};
export default withComponentLoader(AppWrappedDate);
